import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=9fcd40c8&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcd40c8",
  null
  
)

export default component.exports